export const UNLEASH_TOGGLES = {
    addTechnicalContact: 'ui.dcp-commerce-ui.checkout.addTechnicalContact',
    contextualUserMenuCart: 'ui.contextualNavigation.userMenuCart.enabled',
    leadFormCaptcha: 'ui.dcp-commerce-ui.leadForm.captcha.enabled',
    checkoutEstimatedTaxTooltip: 'ui.dcp-commerce-ui.checkout.review.estimatedTaxTooltip.enabled',
    taxNotCalculatedErrorDisplay: 'ui.dcp-commerce-ui.tax-not-calculated-error-display.enabled',
    showQuantityTooltip: 'ui.dcp-commerce-ui.configurator.quantity.showQuantityTooltip',
    showTaxIdField: 'ui.dcp-commerce-ui.checkout.showTaxId',
    globalErrorHandler: 'ui.dcp-commerce-ui.error.globalHandler',
    globalInfoHandler: 'ui.dcp-commerce-ui.info.globalHandler',
    spartacusTagManagement: 'ui.dcp-commerce-ui.adobe.spartacus_tag_management.enabled',
    captureNetNewGlobalAccounts: 'ui.dcp-commerce-ui.checkout.capture_net_new_global_accounts.enabled',
    modalView: 'ui.dcp-commerce-ui.store.modal_view.enabled',
    adobeCampaignTracking: 'ui.dcp-commerce-ui.adobe.campaign_tracking.enabled',
    adobeSearchTracking: 'ui.dcp-commerce-ui.adobe.search_tracking.enabled',
    adobeFormTracking: 'ui.dcp-commerce-ui.adobe.form_tracking.enabled',
    disableEndContactDomainCheck: 'ui.dcp-lambda-customer-registration-decorator.end_contact_domain_tool_call.enabled',
    cpsConfiguratorDisplayTechnicalGroup: 'ui.dcp-commerce-ui.cps.configurator.technical-group-display.enabled',
    reduceConfigureCalls: 'ui.dcp-commerce-ui.configurator.reduce-configure-calls.enabled',
    createNewLocation: 'ui.dcp-commerce-ui.checkout.location_creation.enabled',
    cpsPricePerLicense: 'ui.dcp-commerce-ui.cps.configurator.price_per_license.enabled',
    useWithCredentials: 'ui.dcp-commerce-ui.store.commerce_and_decorator.use_with_credentials',
    checkoutEditAddress: 'ui.dcp-commerce-ui.checkout.data.edit.enabled',
    cpsQuantityMetaInfo: 'ui.dcp-commerce-ui.cps.configurator.quantity-meta-info.enabled',
    adobeEddlEnabled: 'ui.dcp-commerce-ui.adobe.eddl.enabled',
    cpsShowRecurringTotal: 'ui.dcp-commerce-ui.cps.pricing.recurring-total.enabled',
    cpsLoggingEnabled: 'ui.dcp-commerce-ui.cps.logging.enabled',
    mockCcEnabled: 'ui.dcp-commerce-ui.stripe.mock.response.enabled',
    pdpOpenCtaInfoPage: 'ui.dcp-commerce-ui.pdp.open-cta-info-page-modal.enabled',
    cpsPriceTooltip: 'ui.dcp-commerce-ui.cps.pricing.tooltip.enabled',
    registerCreditCardInDPAO: 'ui.dcp-commerce-ui.dpao.registercard.enabled',
    stripeConnectedAccount: 'ui.dcp-commerce-ui.stripe.connectedAccount.enabled',
    showGroupTotal: 'ui.dcp-commerce-ui.cps.pricing.group-total.enabled',
    showRecurringTotal: 'ui.dcp-commerce-ui.cps.pricing.recurring-total.enabled',
    searchIntegrationEnabled: 'ui.dcp-commerce-ui.search.searchIntegration.enabled',
    couponComponentVisible: 'ui.dcp-commerce-ui.show.coupon.component.enabled',
    subtotalGroupPriceCalculationBreakdown: 'ui.dcp-commerce-ui.show.subtotals.price-calculation-breakdown.enabled',
    pricingTooltipPriceCalculationBreakdown: 'ui.dcp-commerce-ui.show.tooltip.subtotals.price-calculation-breakdown.enabled',
    autoBpRegistration: 'ui.dcp-commerce-ui.registration.bp-auto-create.enabled',
    stripeNoPaymentIntent: 'ui.dcp-lambda-psp-integration.stripe.country.no.paymentintent.enabled',
    mouseOverSelectDifferentShipTo: 'ui.dcp-commerce-ui.checkout.mouseover.select.different.shipTo.enable',
    maintenanceDisclaimer: 'ui.dcp-commerce-ui.show.maintenance-disclaimer.enabled',
    delegoFutureContractDateSetValue: 'ui.dcp-commerce-ui.delego.min.amount.currency.auth.enabled',
    delegoDowntimeMinAmount: 'ui.dcp-commerce-ui.delego.min.amount.downtime.auth.enabled',
    sapChatAdvisor: 'ui.dcp-commerce-ui.sapChatAdvisor.enabled',
    useLeadFormWebComoponent: 'ui.dcp-commerce-ui.leadForm.webComponent.enabled',
    cpsAddonsNewNamingConvention: 'ui.dcp-commerce-ui.cps.addon.new_naming_convention.enabled',
    configuratorClearCartOnSkip: 'ui.commerce-ui-libs.skip-configurator.clear-cart.enabled',
    usePrivateOfferWebComponent: 'ui.dcp-commerce-ui.privateOffer.webComponent.enabled',
    usePrivateOfferTestPage: 'ui.dcp-commerce-ui.privateOffer.testPage.enabled',
    mastHeadEnabled: 'ui.dcp-commerce-ui.navigation.masthead.enabled',
    contextualNavigationEnabled: 'ui.dcp-commerce-ui.navigation.contextualNavigation.enabled',
  }
;
